import httpClient from "../http/http-client";
import { IEmailDetails, INewPasswordDetails } from '../user-details/user-details.model';
import { ICheckTokenResponse, IInviteDetails, ILoginDetails, ILoginResponse, IMfaVerifyDetails, IRegisterDetails, IVerificationCode } from './user-auth.model';

export default class UserAuthService {
  http;

  constructor() {
    this.http = httpClient
  }

  async loginUser(loginDetails: ILoginDetails): Promise<ILoginResponse> {
    return this.http.post('login', loginDetails)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  // Verify the second factor for a session held in the MFA-pending state.
  async verifyMfa(details: IMfaVerifyDetails): Promise<any> {
    return this.http.post('login/verify-mfa', details)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  // Resend the emailed login code (email MFA method only).
  async resendMfaLoginCode(): Promise<any> {
    return this.http.post('login/resend-mfa', {})
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  async registerUser(registerDetails: IRegisterDetails): Promise<any> {
    return this.http.post('register', registerDetails)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  async registerUserWithEmailOnly(email: object): Promise<any> {
    return this.http.post('register-email', email)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  async completeEmailOnlyRegistration(details: any): Promise<any> {
    return this.http.post('user/complete-registration', details)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  async logoutUser() {
    return this.http.post('user/logout', [])
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  async verifyCodeUser() {
    return this.http.post('user/new-verification-code', [])
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  async verifyEmailUser(verificationCode: IVerificationCode) {
    return this.http.post('user/verify-email', verificationCode)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  async checkUserToken(token: string): Promise<{ details: ICheckTokenResponse }> {
    return this.http.post('check-token', { token: token })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      })
  }

  async completeUserSignUpFromToken(details: IInviteDetails): Promise<any> {
    return this.http.post('complete-sign-up', details)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      })
  }

  // Accept an invitation for an SSO-enforced org: records terms acceptance (no
  // password). The caller then routes the user into the single sign-on flow.
  async acceptInviteWithSso(details: { token?: string; termsAndConditions: boolean }): Promise<{ email: string }> {
    return this.http.post('accept-invite-sso', details)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      })
  }

  async forgotPassword(email: IEmailDetails): Promise<IEmailDetails> {
    return this.http.post('forgotten-password', email)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      })
  }

  async resetPassword(password: INewPasswordDetails): Promise<INewPasswordDetails> {
    return this.http.post('reset-password', password)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }
}

